import React, { useState, useEffect, useRef } from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";  // Snow theme
import "react-quill/dist/quill.bubble.css";  // Bubble theme
import "./style.css";  // Custom styles for hybrid toolbar
import { Box, Button, InputBase, styled, Tab, Tabs } from "@mui/material";
import Addtags from './Addtags'
import './style.css';
import hljs from 'highlight.js';
import 'highlight.js/styles/atom-one-dark.css';
import Quill from 'quill';



function ReactQuillComp() {
    const [value, setValue] = useState("");
    const quillRef = useRef(null);
    const [valuemui, setValuemui] = React.useState('Edit');
    const [data, setData] = useState({
        coverImage: null,
        title: "",
        tags: []
    })

    const VisuallyHiddenInput = styled('input')({
        clip: 'rect(0 0 0 0)',
        clipPath: 'inset(50%)',
        height: 1,
        overflow: 'hidden',
        position: 'absolute',
        bottom: 0,
        left: 0,
        whiteSpace: 'nowrap',
        width: 1,
    });

    const handleCoverImg = (e) => {
        setData((prev) => ({ ...prev, [e.target.name]: e.target.files[0] }))
    }

    const removeCoverImg = () => {
        setData((prev) => ({ ...prev, ['coverImage']: null }))
    }

    const handleChange = (event, newValue) => {
        setValuemui(newValue);
    };

// For adding custome icons :=>
    const customIcons = Quill.import('ui/icons');
    customIcons['code-block'] ='<svg fill="white" xmlns="http://www.w3.org/2000/svg" xml:space="preserve" id="Code" x="0" y="0" fill="#000" version="1.1" viewBox="0 0 48 48"> <path d="M39 48H9c-4.971 0-9-4.032-9-9V9a9 9 0 0 1 9-9h30c4.968 0 9 4.029 9 9v30c0 4.968-4.032 9-9 9zm3-39a3 3 0 0 0-3-3H9C7.344 6 6 7.344 6 9v30a3 3 0 0 0 3 3h30c1.659 0 3-1.341 3-3V9zm-6 18v3c0 4.968-4.032 9-9 9v-6c1.659 0 3-1.341 3-3v-3a3 3 0 1 0 0-6v-3a3 3 0 0 0-3-3V9c4.968 0 9 4.029 9 9v3a3 3 0 1 1 0 6zm-24 3v-3a3.001 3.001 0 0 1 0-6v-3a9 9 0 0 1 9-9v6c-1.656 0-3 1.344-3 3v3a3.001 3.001 0 0 0 0 6v3a3 3 0 0 0 3 3v6c-4.971 0-9-4.032-9-9z" class="color000000 svgShape"></path> </svg>'

    const modules = {
        toolbar: [
            [{ 'header': '2' }],
            [{ size: ['small', false, 'large', 'huge'] }], // Add size options
            ['bold', 'italic', 'underline', 'strike', 'blockquote', 'code-block', 'code'],
            [{ 'list': 'ordered' }, { 'list': 'bullet' }],
            ['link', 'image'],
            ['clean']
        ]
    };

    const previewRef = useRef(null);

// Apply highlight.js to the code block
    useEffect(() => {
        if (previewRef.current) {
            const codeBlocks = previewRef.current.querySelectorAll('.ql-syntax');
            codeBlocks.forEach((block) => {
                hljs.highlightBlock(block);  
            });
        }
    }, [value, valuemui]);  


//   for bubble effect 
    useEffect(() => {
        if (valuemui == "Edit") {
            const quill = quillRef.current.getEditor();
            console.log(quillRef.current.getEditor(),"::DfsquillRef978")
            const bubbleToolbar = document.querySelector('.bubble-toolbar');
            // Show bubble toolbar when text is selected
            quill.on('selection-change', (range) => {
                if (range && range.length > 0) {
                    const selectionBounds = quill.getBounds(range);
                    bubbleToolbar.style.display = 'flex';
                    bubbleToolbar.style.top = `${selectionBounds.top }px`;
                    bubbleToolbar.style.left = `${selectionBounds.left }px`;
                } else {
                    bubbleToolbar.style.display = 'none';
                }
            });

            // Set up event listeners for the bubble toolbar buttons
            document.querySelector('.bubble-bold').addEventListener('click', () => {
                quill.format('bold', true);  // Apply bold formatting
            });
            document.querySelector('.bubble-italic').addEventListener('click', () => {
                quill.format('italic', true);  // Apply italic formatting
            });
            document.querySelector('.bubble-underline').addEventListener('click', () => {
                quill.format('underline', true);  // Apply underline formatting
            });
            document.querySelector('.bubble-link').addEventListener('click', () => {
                const href = prompt('Enter the URL:');
                if (href) {
                    quill.format('link', href);  // Apply link formatting
                }
            });
        }
    }, [valuemui]);


   

    useEffect(() => {
        const resizeObserverError = (event) => {
            if (event.message === 'ResizeObserver loop completed with undelivered notifications.') {
                event.stopImmediatePropagation();
            }
        };

        window.addEventListener('error', resizeObserverError);
        return () => {
            window.removeEventListener('error', resizeObserverError);
        };
    }, []);

    useEffect(() => {
        const observer = new ResizeObserver(() => {
            // Prevent the ResizeObserver loop error
            try {
                const quill = quillRef.current.getEditor();
                quill.root.style.overflow = 'auto';  // Handle overflow styles
            } catch (err) {
                console.warn('Error in ResizeObserver', err);
            }
        });

        observer.observe(document.querySelector('.ql-container'));

        return () => {
            observer.disconnect();  // Clean up when component unmounts
        };
    }, []);


    return (
        <>
            <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", color: "white" }}>
                <Box>Editor</Box>
                <Box sx={{ color: "white" }}>
                    <Tabs
                        value={valuemui}
                        onChange={handleChange}
                    >
                        <Tab sx={{ color: "white" }} value="Edit" label="Edit" />
                        <Tab sx={{ color: "white" }} value="Preview" label="Preview" />
                    </Tabs>
                </Box>
            </Box>
            {
                valuemui === "Edit" ?
                    <>
                        <Box sx={{ padding: "32px 64px", background: "#171717" }}>
                            <Box sx={{ display: "flex", flexDirection: "column", alignItems: "flex-start", gap: "10px" }}>
                                <Box display={"flex"} justifyContent={"start"} gap={"10px"} alignItems={"center"}>
                                    {
                                        data.coverImage &&
                                        <img
                                            src={URL.createObjectURL(data?.coverImage)}
                                            alt={"cover-image"}
                                            style={{ width: '200px', height: '200px', objectFit: 'cover' }}
                                        />
                                    }
                                    <Button
                                        component="label"
                                        role={undefined}
                                        variant="outlined"
                                        tabIndex={-1}
                                    >
                                        {data.coverImage ? 'Change' : 'Add a cover image'}
                                        <VisuallyHiddenInput
                                            type="file"
                                            name="coverImage"
                                            onChange={(e) => handleCoverImg(e)}
                                        />
                                    </Button>
                                    {data.coverImage && <Button variant="text" color="error" onClick={removeCoverImg}>Remove</Button>}
                                </Box>
                                <InputBase
                                    sx={{ color: "white", fontSize: "3rem", whiteSpace: "pre-wrap", fontWeight: 800, lineHeight: 1.25 }}
                                    placeholder="New post title here..."
                                    fullWidth
                                    multiline
                                    value={data.title}
                                    name="title"
                                    onChange={(e) => setData((prev) => ({ ...prev, [e.target.name]: e.target.value }))}
                                />
                                <Addtags data={data} setData={setData} />
                            </Box>
                        </Box>
                        <Box sx={{position: "relative"}}>
                            <ReactQuill
                                ref={quillRef}
                                defaultValue="Hello"
                                modules={modules}
                                theme="snow"
                                value={value}
                                onChange={setValue}
                            />

                            {/* Bubble toolbar (custom implementation to show on selection) */}
                            <div className="bubble-toolbar">
                                <button className="bubble-bold">B</button>
                                <button className="bubble-italic">I</button>
                                <button className="bubble-underline">U</button>
                                <button className="bubble-link">Link</button>
                            </div>
                        </Box>

                        <Box className="bottom-actions" sx={{ marginTop: "8px", display: "flex", gap: "10px" }}>
                            <Button variant="contained">Publish</Button>
                            <Button variant="text">Save draft</Button>
                        </Box>

                    </> :
                    <>
                        <Box sx={{ background: "#171717", color: "white", width: "800px", height: "730px", overflow: "auto" }}>
                            <Box>
                                {
                                    data.coverImage &&
                                    <img
                                        src={URL.createObjectURL(data?.coverImage)}
                                        alt={"cover-image"}
                                        style={{ width: '100%', height: "100%", objectFit: "contain" }}
                                    />
                                }
                            </Box>
                            <Box sx={{ padding: "32px 64px" }}>
                                <h1 style={{ textAlign: "start" }}>{data.title}</h1>
                                <Box display={"flex"} justifyContent={"start"} alignItems={"start"} gap={"10px"}>
                                    {
                                        data?.tags?.map((item) => (
                                            <span>{item.title}</span>
                                        ))
                                    }
                                </Box>
                                <div ref={previewRef} className="preview-section" dangerouslySetInnerHTML={{ __html: value }}></div>
                            </Box>
                        </Box>
                        <Box className="bottom-actions" sx={{ marginTop: "8px", display: "flex", gap: "10px" }}>
                            <Button variant="contained">Publish</Button>
                            <Button variant="text">Save draft</Button>
                        </Box>
                    </>
            }


        </>
    );
}

export default ReactQuillComp;
